import { Component, OnInit } from '@angular/core';
import { RouterLink } from '@angular/router';
import { AuthModalFacade } from '@curbnturf/auth-modal/src/lib/+state/auth-modal.facade';
import { AuthModalsComponent } from '@curbnturf/auth-modal/src/lib/auth-modals/auth-modals.component';
import { StatusFacade } from '@curbnturf/status/src/lib/status.facade';
import {
  IonContent,
  IonHeader,
  IonIcon,
  IonItem,
  IonLabel,
  IonList,
  IonMenu,
  IonTitle,
  IonToolbar,
} from '@ionic/angular/standalone';
import { addIcons } from 'ionicons';
import {
  albums,
  bonfire,
  key,
  location,
  mail,
  people,
  person,
  pin,
  search,
  server,
  statsChart,
  ticket,
  today,
  wallet,
} from 'ionicons/icons';
import { Observable } from 'rxjs';

@Component({
  selector: 'curbnturf-admin-header',
  templateUrl: './admin-header.component.html',
  styleUrls: ['./admin-header.component.scss'],
  standalone: true,
  imports: [
    AuthModalsComponent,
    IonContent,
    IonIcon,
    IonItem,
    IonHeader,
    IonLabel,
    IonList,
    IonMenu,
    IonTitle,
    IonToolbar,
    RouterLink,
  ],
})
export class AdminHeaderComponent implements OnInit {
  loggedIn$: Observable<boolean>;

  constructor(
    private authModalFacade: AuthModalFacade,
    private statusFacade: StatusFacade,
  ) {
    addIcons({
      person,
      ticket,
      location,
      people,
      bonfire,
      pin,
      server,
      key,
      search,
      statsChart,
      wallet,
      albums,
      mail,
      today,
    });
  }

  ngOnInit() {
    this.loggedIn$ = this.statusFacade.loggedIn$;
  }

  openLoginModal() {
    this.authModalFacade.openAuthModal('login');
  }
}
